export const EMOJI_SIZE = 20;
